import n, { useRef as e, useEffect as r } from "react";
import o from "prop-types";
import a from "@leafygreen-ui/box";
import { css as t, cx as l } from "@leafygreen-ui/emotion";
import { registerRipple as i } from "@leafygreen-ui/ripple";
import { useUsingKeyboardContext as c } from "@leafygreen-ui/leafygreen-provider";
import { transparentize as d, mix as g } from "polished";
import { palette as s, uiColors as b } from "@leafygreen-ui/palette";
import { fontFamilies as u, typeScales as p } from "@leafygreen-ui/tokens";
import { createDataProp as h } from "@leafygreen-ui/lib";
import { jsx as f } from "@emotion/react";

function y(n, e) {
  var r = Object.keys(n);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);
    e && (o = o.filter(function (e) {
      return Object.getOwnPropertyDescriptor(n, e).enumerable;
    })), r.push.apply(r, o);
  }

  return r;
}

function x(n) {
  for (var e = 1; e < arguments.length; e++) {
    var r = null != arguments[e] ? arguments[e] : {};
    e % 2 ? y(Object(r), !0).forEach(function (e) {
      k(n, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : y(Object(r)).forEach(function (e) {
      Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return n;
}

function k(n, e, r) {
  return e in n ? Object.defineProperty(n, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = r, n;
}

function m() {
  return m = Object.assign || function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var o in r) {
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
      }
    }

    return n;
  }, m.apply(this, arguments);
}

function w(n, e) {
  if (null == n) return {};

  var r,
      o,
      a = function (n, e) {
    if (null == n) return {};
    var r,
        o,
        a = {},
        t = Object.keys(n);

    for (o = 0; o < t.length; o++) {
      r = t[o], e.indexOf(r) >= 0 || (a[r] = n[r]);
    }

    return a;
  }(n, e);

  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(n);

    for (o = 0; o < t.length; o++) {
      r = t[o], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(n, r) && (a[r] = n[r]);
    }
  }

  return a;
}

function v(n, e) {
  return e || (e = n.slice(0)), Object.freeze(Object.defineProperties(n, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}

var O,
    D,
    P,
    j,
    z,
    B,
    S,
    G,
    N,
    M,
    q,
    F,
    C,
    E,
    I,
    L,
    X,
    K,
    H,
    R,
    T,
    Y,
    A,
    J,
    Q,
    U,
    V,
    W,
    Z,
    $,
    _,
    nn,
    en,
    rn,
    on,
    an,
    tn,
    ln,
    cn,
    dn,
    gn,
    sn,
    bn,
    un,
    pn,
    hn,
    fn,
    yn,
    xn,
    kn,
    mn,
    wn,
    vn = {
  Default: "default",
  Primary: "primary",
  PrimaryOutline: "primaryOutline",
  Danger: "danger",
  DangerOutline: "dangerOutline",
  BaseGreen: "baseGreen"
},
    On = {
  XSmall: "xsmall",
  Small: "small",
  Default: "default",
  Large: "large"
},
    Dn = "light",
    Pn = "dark",
    jn = {
  Body1: 13,
  Body2: 16
},
    zn = function zn(n) {
  return "\n    0 0 0 2px ".concat(n, ", \n    0 0 0 4px ").concat(s.blue.light1, ";\n");
},
    Bn = t(O || (O = v(["\n  // unset browser default\n  appearance: none;\n  padding: 0;\n  margin: 0;\n  background-color: transparent;\n  border: 1px solid transparent;\n  display: inline-flex;\n  align-items: stretch;\n  transition: all 150ms ease-in-out;\n  position: relative;\n  text-decoration: none;\n  cursor: pointer;\n  z-index: 0;\n  font-family: ", ";\n  border-radius: 6px;\n\n  &:focus {\n    outline: none;\n  }\n\n  &[disabled],\n  &:disabled {\n    pointer-events: none;\n  }\n\n  &:active,\n  &:focus,\n  &:hover {\n    text-decoration: none;\n  }\n"])), u.default),
    Sn = (k(L = {}, Dn, (k(G = {}, vn.Default, t(D || (D = v(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:hover,\n      &:active {\n        background-color: ", ";\n        box-shadow: 0 0 0 3px ", ";\n      }\n    "])), s.gray.light3, s.gray.base, s.gray.dark3, s.white, s.gray.light2)), k(G, vn.Primary, t(P || (P = v(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: #00593f; // Not quite dark3\n        border-color: #00593f; // Not quite dark3\n        box-shadow: 0 0 0 3px ", ";\n      }\n    "])), s.green.dark2, s.green.dark2, s.white, s.white, s.green.light2)), k(G, vn.PrimaryOutline, t(j || (j = v(["\n      background-color: transparent;\n      border-color: ", ";\n      color: ", ";\n\n      &:hover,\n      &:active {\n        background-color: ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.green.dark2, s.green.dark2, d(.96, s.green.base), s.green.light2)), k(G, vn.Danger, t(z || (z = v(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: #c82222; // not quite dark1\n        border-color: #c82222; // not quite dark1\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.red.base, s.red.base, s.white, s.white, s.red.light3)), k(G, vn.DangerOutline, t(B || (B = v(["\n      background-color: transparent;\n      border-color: ", ";\n      color: ", ";\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.red.light1, s.red.base, s.red.dark2, d(.96, s.red.base), s.red.base, s.red.light3)), k(G, vn.BaseGreen, t(S || (S = v(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:hover,\n      &:active {\n        background-color: ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.green.base, s.green.dark2, s.green.dark3, g(.96, s.green.base, s.green.dark3), s.green.light2)), G)), k(L, Pn, (k(I = {}, vn.Default, t(N || (N = v(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        background-color: ", ";\n        border-color: ", ";\n        color: ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.gray.dark2, s.gray.base, s.white, s.white, s.gray.dark1, s.gray.base, s.white, s.gray.dark2)), k(I, vn.Primary, t(M || (M = v(["\n      background-color: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: #00593f; // Off palette\n        box-shadow: 0 0 0 3px ", ";\n      }\n    "])), s.green.dark2, s.green.base, s.white, s.white, s.white, s.green.dark3)), k(I, vn.PrimaryOutline, t(q || (q = v(["\n      background-color: transparent;\n      border-color: ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.green.base, s.green.base, s.green.base, s.green.base, d(.96, s.green.base), s.green.base, s.green.dark3)), k(I, vn.Danger, t(F || (F = v(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        border-color: ", ";\n        color: ", ";\n        background-color: #c82222; // Off palette\n        box-shadow: 0px 0px 0px 3px ", "; // yes, yellow\n      }\n    "])), s.red.base, s.red.light1, s.white, s.white, s.red.light1, s.white, s.yellow.dark3)), k(I, vn.DangerOutline, t(C || (C = v(["\n      border-color: ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        box-shadow: 0px 0px 0px 3px ", "; // yes, yellow\n      }\n    "])), s.red.light1, s.red.light1, s.red.light1, s.red.light1, d(.96, s.red.base), s.yellow.dark3)), k(I, vn.BaseGreen, t(E || (E = v(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:hover,\n      &:active {\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.green.base, s.green.dark2, s.green.dark3, g(.96, s.green.base, s.green.light3), s.green.dark2, s.green.dark3)), I)), L),
    Gn = (k(_ = {}, Dn, (k(A = {}, vn.Default, t(X || (X = v(["\n      &:focus {\n        background-color: ", ";\n        box-shadow: ", ";\n      }\n    "])), s.white, zn(s.white))), k(A, vn.Primary, t(K || (K = v(["\n      &:focus {\n        color: ", ";\n        background-color: #00593f; // Not quite dark3\n        box-shadow: ", ";\n      }\n    "])), s.white, zn(s.white))), k(A, vn.PrimaryOutline, t(H || (H = v(["\n      &:focus {\n        background-color: ", ";\n        box-shadow: ", ";\n      }\n    "])), d(.96, s.green.base), zn(s.white))), k(A, vn.Danger, t(R || (R = v(["\n      &:focus {\n        color: ", ";\n        background-color: #c82222; // not quite dark1\n        box-shadow: ", ";\n      }\n    "])), s.white, zn(s.white))), k(A, vn.DangerOutline, t(T || (T = v(["\n      &:focus {\n        color: ", ";\n        box-shadow: ", ";\n      }\n    "])), s.red.dark2, zn(s.white))), k(A, vn.BaseGreen, t(Y || (Y = v(["\n      &:focus {\n        box-shadow: ", ";\n      }\n    "])), zn(s.white))), A)), k(_, Pn, (k($ = {}, vn.Default, t(J || (J = v(["\n      &:focus {\n        background-color: ", ";\n        box-shadow: ", ";\n      }\n    "])), s.gray.dark1, zn(s.black))), k($, vn.Primary, t(Q || (Q = v(["\n      &:focus {\n        background-color: #00593f; // Off palette\n        box-shadow: ", ";\n      }\n    "])), zn(s.black))), k($, vn.PrimaryOutline, t(U || (U = v(["\n      &:focus {\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: ", ";\n      }\n    "])), d(.96, s.green.base), s.green.base, zn(s.black))), k($, vn.Danger, t(V || (V = v(["\n      &:focus {\n        background-color: #c82222; // Off palette\n        box-shadow: ", ";\n      }\n    "])), zn(s.black))), k($, vn.DangerOutline, t(W || (W = v(["\n      &:focus {\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: ", ";\n      }\n    "])), d(.96, s.red.base), s.red.light1, zn(s.black))), k($, vn.BaseGreen, t(Z || (Z = v(["\n      &:focus {\n        background-color: ", ";\n        box-shadow: ", ";\n      }\n    "])), s.green.base, zn(s.black))), $)), _),
    Nn = (k(rn = {}, Dn, t(nn || (nn = v(["\n    &,\n    &:hover {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n      cursor: not-allowed;\n    }\n\n    &:focus {\n      box-shadow: ", ";\n    }\n  "])), s.gray.light2, s.gray.light1, s.gray.base, zn(s.white))), k(rn, Pn, t(en || (en = v(["\n    &,\n    &:hover {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n      cursor: not-allowed;\n    }\n\n    &:focus {\n      box-shadow: ", ";\n    }\n  "])), s.gray.dark3, s.gray.dark1, s.gray.dark1, zn(s.black))), rn),
    Mn = (k(cn = {}, On.XSmall, t(on || (on = v(["\n    height: 22px;\n    text-transform: uppercase;\n    font-size: 12px;\n    line-height: 1em;\n    font-weight: bold;\n    letter-spacing: 0.4px;\n  "])))), k(cn, On.Small, t(an || (an = v(["\n    height: 28px;\n  "])))), k(cn, On.Default, t(tn || (tn = v(["\n    height: 36px;\n  "])))), k(cn, On.Large, t(ln || (ln = v(["\n    height: 48px;\n    font-size: 18px;\n    line-height: 24px;\n  "])))), cn),
    qn = (k(sn = {}, jn.Body1, t(dn || (dn = v(["\n    font-size: ", "px;\n    line-height: ", "px;\n    font-weight: 500; // Medium\n  "])), p.body1.fontSize, p.body1.lineHeight)), k(sn, jn.Body2, t(gn || (gn = v(["\n    font-size: ", "px;\n    line-height: ", "px;\n    // Pixel pushing for optical alignment purposes\n    transform: translateY(1px);\n    font-weight: 500; // Medium\n  "])), p.body2.fontSize, p.body2.lineHeight)), sn),
    Fn = h("button");

var Cn,
    En,
    In,
    Ln,
    Xn,
    Kn,
    Hn,
    Rn,
    Tn,
    Yn,
    An,
    Jn,
    Qn,
    Un,
    Vn,
    Wn,
    Zn,
    $n,
    _n,
    ne,
    ee,
    re,
    oe,
    ae,
    te,
    le,
    ie,
    ce,
    de,
    ge,
    se,
    be,
    ue,
    pe,
    he,
    fe,
    ye,
    xe,
    ke,
    me,
    we,
    ve,
    Oe,
    De = (k(pn = {}, Dn, (k(bn = {}, vn.Default, s.gray.light2), k(bn, vn.Primary, s.green.dark1), k(bn, vn.PrimaryOutline, d(.76, s.green.base)), k(bn, vn.Danger, s.red.light1), k(bn, vn.DangerOutline, d(.76, s.red.base)), k(bn, vn.BaseGreen, s.green.light1), bn)), k(pn, Pn, (k(un = {}, vn.Default, s.gray.base), k(un, vn.Primary, s.green.dark1), k(un, vn.PrimaryOutline, d(.76, s.green.base)), k(un, vn.Danger, s.red.dark2), k(un, vn.DangerOutline, d(.76, s.red.light1)), k(un, vn.BaseGreen, s.green.dark1), un)), pn),
    Pe = t(hn || (hn = v(["\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 5px;\n"]))),
    je = t(fn || (fn = v(["\n  display: grid;\n  grid-auto-flow: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  pointer-events: none;\n  position: relative;\n  z-index: 0;\n"]))),
    ze = (k(wn = {}, On.XSmall, t(yn || (yn = v(["\n    padding: 0 7px; // 8px - 1px border\n    gap: 6px;\n  "])))), k(wn, On.Small, t(xn || (xn = v(["\n    padding: 0 11px; // 12px - 1px border\n    gap: 6px;\n  "])))), k(wn, On.Default, t(kn || (kn = v(["\n    padding: 0 11px; // 12px - 1px border\n    gap: 6px;\n  "])))), k(wn, On.Large, t(mn || (mn = v(["\n    padding: 0 15px; // 16px - 1px border\n    gap: 8px;\n  "])))), wn),
    Be = (k(Vn = {}, Dn, (k(Hn = {}, vn.Default, t(Cn || (Cn = v(["\n      color: ", ";\n    "])), s.gray.base)), k(Hn, vn.Primary, t(En || (En = v(["\n      color: ", ";\n    "])), s.green.light2)), k(Hn, vn.PrimaryOutline, t(In || (In = v(["\n      color: ", ";\n    "])), s.green.dark2)), k(Hn, vn.Danger, t(Ln || (Ln = v(["\n      color: ", ";\n    "])), s.red.light3)), k(Hn, vn.DangerOutline, t(Xn || (Xn = v(["\n      color: ", ";\n    "])), s.red.light1)), k(Hn, vn.BaseGreen, t(Kn || (Kn = v(["\n      color: ", ";\n    "])), s.green.dark2)), Hn)), k(Vn, Pn, (k(Un = {}, vn.Default, t(Rn || (Rn = v(["\n      color: ", ";\n    "])), s.gray.light2)), k(Un, vn.Primary, t(Tn || (Tn = v(["\n      color: ", ";\n    "])), s.green.light2)), k(Un, vn.PrimaryOutline, t(Yn || (Yn = v(["\n      color: ", ";\n    "])), s.green.base)), k(Un, vn.Danger, t(An || (An = v(["\n      color: ", ";\n    "])), s.red.light2)), k(Un, vn.DangerOutline, t(Jn || (Jn = v(["\n      color: ", ";\n    "])), s.red.light1)), k(Un, vn.BaseGreen, t(Qn || (Qn = v(["\n      color: ", ";\n    "])), b.green.dark3)), Un)), Vn),
    Se = (k(ge = {}, Dn, (k(re = {}, vn.Default, t(Wn || (Wn = v(["\n      color: ", ";\n    "])), s.gray.dark1)), k(re, vn.Primary, t(Zn || (Zn = v(["\n      color: ", ";\n    "])), s.green.light3)), k(re, vn.PrimaryOutline, t($n || ($n = v(["\n      color: ", ";\n    "])), s.green.dark2)), k(re, vn.Danger, t(_n || (_n = v(["\n      color: ", ";\n    "])), s.red.light3)), k(re, vn.DangerOutline, t(ne || (ne = v(["\n      color: ", ";\n    "])), s.red.light1)), k(re, vn.BaseGreen, t(ee || (ee = v(["\n      color: ", ";\n    "])), s.green.dark2)), re)), k(ge, Pn, (k(de = {}, vn.Default, t(oe || (oe = v(["\n      color: ", ";\n    "])), s.gray.light3)), k(de, vn.Primary, t(ae || (ae = v(["\n      color: ", ";\n    "])), s.green.light3)), k(de, vn.PrimaryOutline, t(te || (te = v(["\n      color: ", ";\n    "])), s.green.base)), k(de, vn.Danger, t(le || (le = v(["\n      color: ", ";\n    "])), s.red.light3)), k(de, vn.DangerOutline, t(ie || (ie = v(["\n      color: ", ";\n    "])), s.red.light1)), k(de, vn.BaseGreen, t(ce || (ce = v(["\n      color: ", ";\n    "])), b.green.dark3)), de)), ge),
    Ge = t(se || (se = v(["\n  ", ":hover &,\n  ", ":active & {\n    color: currentColor;\n  } ;\n"])), Fn.selector, Fn.selector),
    Ne = (k(fe = {}, On.XSmall, t(be || (be = v(["\n    height: 14px;\n    width: 14px;\n  "])))), k(fe, On.Small, t(ue || (ue = v(["\n    height: 16px;\n    width: 16px;\n  "])))), k(fe, On.Default, t(pe || (pe = v(["\n    height: 16px;\n    width: 16px;\n  "])))), k(fe, On.Large, t(he || (he = v(["\n    height: 20px;\n    width: 20px;\n  "])))), fe),
    Me = (k(ke = {}, Dn, t(ye || (ye = v(["\n    color: ", ";\n  "])), s.gray.light2)), k(ke, Pn, t(xe || (xe = v(["\n    color: ", ";\n  "])), s.gray.dark1)), ke),
    qe = t(me || (me = v(["\n  color: ", ";\n"])), s.gray.light1);

function Fe(e) {
  var r,
      o = e.glyph,
      a = e.variant,
      t = e.size,
      i = e.darkMode,
      c = e.disabled,
      d = e.isIconOnlyButton,
      g = e.className,
      s = !d && {
    "aria-hidden": !0,
    role: "presentation"
  },
      b = i ? Pn : Dn,
      u = d ? Se : Be;
  return n.cloneElement(o, x({
    className: l(u[b][a], Ne[t], (r = {}, k(r, Me[b], c), k(r, Ge, d), k(r, qe, !i && c && d), r), g)
  }, s));
}

Fe.displayName = "ButtonIcon";
var Ce = ["variant", "size", "darkMode", "baseFontSize", "disabled", "onClick", "leftGlyph", "rightGlyph", "children", "className", "as", "type"],
    Ee = n.forwardRef(function (o, d) {
  var g,
      s = o.variant,
      b = void 0 === s ? vn.Default : s,
      u = o.size,
      p = void 0 === u ? On.Default : u,
      h = o.darkMode,
      y = void 0 !== h && h,
      O = o.baseFontSize,
      D = void 0 === O ? jn.Body1 : O,
      P = o.disabled,
      j = void 0 !== P && P,
      z = o.onClick,
      B = o.leftGlyph,
      S = o.rightGlyph,
      G = o.children,
      N = o.className,
      M = o.as,
      q = o.type,
      F = w(o, Ce),
      C = c().usingKeyboard,
      E = e(null);
  r(function () {
    var n,
        e = De[y ? Pn : Dn][b];
    return null == E.current || j || (n = i(E.current, {
      backgroundColor: e
    })), n;
  }, [E, b, y, j]);

  var I = null !== (g = (B || S) && !G) && void 0 !== g && g,
      L = function (n) {
    var e = n.variant,
        r = n.size,
        o = n.darkMode,
        a = n.baseFontSize,
        t = n.disabled,
        i = n.usingKeyboard,
        c = o ? Pn : Dn,
        d = Sn[c][e],
        g = Gn[c][e];
    return l(Bn, d, qn[a], Mn[r], k({}, g, i && !t), k({}, Nn[c], t));
  }({
    variant: b,
    size: p,
    darkMode: y,
    baseFontSize: D,
    disabled: j,
    usingKeyboard: C
  }),
      X = !(!F.href && "a" !== M || j),
      K = x(x(x({
    type: X ? void 0 : q || "button",
    className: l(L, N),
    ref: d,
    as: M || (X ? "a" : "button")
  }, "string" != typeof F.href && {
    disabled: j
  }), {}, {
    "aria-disabled": j,
    onClick: j ? void 0 : z
  }, Fn.prop), F),
      H = {
    variant: b,
    size: p,
    darkMode: y,
    disabled: j,
    isIconOnlyButton: I
  },
      R = f(n.Fragment, null, f("div", {
    className: l(Pe),
    ref: E
  }), f("div", {
    className: l(je, ze[p], k({}, t(we || (we = v(["\n              justify-content: space-between;\n            "]))), !!S && y))
  }, B && f(Fe, m({
    glyph: B,
    className: t(ve || (ve = v(["\n                justify-self: right;\n              "])))
  }, H)), G, S && f(Fe, m({
    glyph: S,
    className: t(Oe || (Oe = v(["\n                justify-self: left;\n              "])))
  }, H))));

  return f(a, K, R);
});
Ee.displayName = "Button", Ee.propTypes = {
  variant: o.oneOf(Object.values(vn)),
  baseFontSize: o.oneOf(Object.values(jn)),
  size: o.oneOf(Object.values(On)),
  darkMode: o.bool,
  disabled: o.bool,
  leftGlyph: o.element,
  rightGlyph: o.element,
  href: o.string
};
export { jn as FontSize, On as Size, vn as Variant, Ee as default };